<template>
  <div class="contextmenu-container" style='z-index: 99999'>
    <div v-show='menuData.visible' :style="{ left: menuData.left + 'px', top: menuData.top + 'px' }" class='menu'>
      <div v-if='userPermissions.indexOf("lb_kol_dress_selection_list")>-1' class='contextmenu__item'
           @click="checkEvent('dress')"><i class='el-icon-user'></i>&nbsp;&nbsp;{{ isLbKolRoute ? '服饰选品' : '服饰定品' }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'KolContextmenu',
  props: {
    menuData: {
      type: Object,
      default() {
        return {
          visible: false,
          top: 0,
          left: 0
        }
      }
    },
    id: {
      type: [Number, String],
      default() {
        return undefined
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    isLbKolRoute() {
      return this.$route.name === 'LbScheduleKol'
    }
  },
  methods: {
    checkEvent(val) {
      this.$emit('change', val)
      this.menuData.visible = false
    }
  }
}
</script>

<style scoped>
.contextmenu__item {
    display: block;
    line-height: 30px;
    text-align: left;
    padding-left: 10px;
}

.menu {
    position: fixed;
    background-color: #fff;
    width: 120px;
    /*height: 106px;*/
    font-size: 14px;
    color: #444040;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    white-space: nowrap;
    text-align: left;
    z-index: 9999;
}
</style>
